export const LayoutType = {
  MENU: 0,
  ARTICLES_1_COL: 1,
  ARTICLES_2_COL: 2,
  CARD_LIST: 3,
  BRANCH_LIST: 4,
  HTML_CONTENT: 5,
  BRANCH: 6,
  CARD: 7,
  CUSTOM: 9
};
